// @vendor
const React = require('react');
// @utilities
import { FormattedText } from 'core/i18n';
import './timeMessage.scss';

class TimeMessage extends React.PureComponent {
    render() {
        return (
            <div className="message-box red-box time-message-container">
                <i className="icons icons--icon-alert-msg" />
                <p className="font-paragraph2">
                    <FormattedText value="identity-serviceNoAvailable" />
                </p>
            </div>
        );
    }
}

export { TimeMessage };
